import { GraphQLClient } from 'graphql-request';
import getConfig from 'next/config';
const endpoint = getConfig().publicRuntimeConfig.graphqlURL;
const options = {
  credentials: 'include'
};
const fetcher = (query, vars) => {
  // cannot build client statically
  // https://github.com/graffle-js/graffle/issues/745
  const client = new GraphQLClient(new URL(endpoint, window.location.origin), options);
  return client.request(query, vars);
};
export default fetcher;